import { DateTimeFormatter, LocalDate, LocalDateTime } from 'js-joda';

export const cardExpiryMatchesPattern = (expiry: string) => {
  return expiry.match(/[\d]{2}\/[\d]{2}/);
};

const PAYMENT_CARD_HOLD_GRACE_PERIOD_DAYS = 7;
export const isExpiryAfterServiceDate = (serviceDateTimeISO: string, expiry: string) => {
  const reservationDateTime = LocalDateTime.parse(
    serviceDateTimeISO,
    DateTimeFormatter.ISO_LOCAL_DATE_TIME
  );
  return LocalDate.parse(`01/${expiry}`, DateTimeFormatter.ofPattern('dd/MM/uu'))
    .plusMonths(1)
    .atStartOfDay()
    .isAfter(reservationDateTime.plusDays(PAYMENT_CARD_HOLD_GRACE_PERIOD_DAYS));
};
